type IProps = {
	onButtonClick: () => void;
	label: string;
	buttonStyle?: string;
	labelStyle?: string;
};
const Button = ({ label, labelStyle, buttonStyle, onButtonClick }: IProps) => {
	const handleButtonClick = () => {
		onButtonClick();
	};
	return (
		<button
			className={`w-[100px] px-4 py-2 cursor-pointer rounded-lg  ${buttonStyle || ''}`}
			onClick={() => handleButtonClick()}
		>
			<p className={` ${labelStyle || ''}`}>{label}</p>
		</button>
	);
};

export default Button;
